// extracted by mini-css-extract-plugin
module.exports = {"content":"nFDcn","misc-1":"_5eEj7","title":"CW+am","logo":"_8Mps5"};